module.exports = require("@cybs-ui/components/lib/pagination");